import "./Navbar.css"; // Import the CSS file for styling
import { Link } from "react-router-dom";
import LogoNaranja from '../../assets/Logo_Naranja.png'; // Adjust the path as necessary
import { useState, useEffect, useRef } from "react";

function Navbar() {
  const [open, setOpen] = useState(false);
  const navRef = useRef(null);

  // cerrar menú al cambiar tamaño de ventana (por ejemplo al pasar a desktop)
  useEffect(() => {
    function handleResize() {
      if (window.innerWidth > 800) setOpen(false);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // cerrar menú al hacer click fuera (solo cuando está abierto)
  useEffect(() => {
    function handleClickOutside(e) {
      if (open && navRef.current && !navRef.current.contains(e.target)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [open]);

  return (
    <>
      <nav
        ref={navRef}
        className="navbar"
        style={{ backgroundColor: "#F5F5DC" }}
      >
        <div className="navbarContainer" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <img id='textContainer' src={LogoNaranja} alt="Timeline Logo" style={{ height: "40px", width: "auto" }} />
        </div>

        <div
          role="button"
          className={`hamburger ${open ? "open" : ""}`}
          aria-label="Menú"
          aria-expanded={open}
          onClick={() => setOpen((s) => !s)}
        >
          <span />
          <span />
          <span />
        </div>

        <div className={`navbar-links ${open ? "open" : ""}`}>
          <Link to="/home" style={{ color: "#FF9800", textDecoration: "none", fontWeight: "bold" }}>
            Home
          </Link>

          <Link to="/about" style={{ color: "#FF9800", textDecoration: "none", fontWeight: "bold" }}>
            About
          </Link>

          <Link to="/services" style={{ color: "#FF9800", textDecoration: "none", fontWeight: "bold" }}>
            Services
          </Link>

          <Link to="/contact" style={{ color: "#FF9800", textDecoration: "none", fontWeight: "bold" }}>
            Contact
          </Link>
        </div>
      </nav>
    </>
  );
}

export default Navbar;